
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/notifications",
      function () {
        return require("private-next-pages/me/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/notifications"])
      });
    }
  